import { useMutation, useQueryClient } from '@tanstack/react-query';

import BackendService from '../services/backendService';
import { NewPresentationMetadata } from '../services/backendService/types';
import { presentationsCacheKey } from './usePresentations';
import { templatesCacheKey } from './useTemplates';

export const useNewPresentationId = () => {
  const client = useQueryClient();
  const { mutate: createPresentationId, isLoading } = useMutation({
    mutationFn: async (variables: {
      onSuccess: (id: string) => void;
      metadata?: NewPresentationMetadata;
    }) => {
      return await BackendService.instance.presentations.newPresentationId(
        variables.metadata,
      );
    },
    onSuccess: (data, arg) => {
      arg.onSuccess(data.id);
      // Invalidate templates cache to get the latest template refresh if the user goes back to my lessons
      client.invalidateQueries([templatesCacheKey]);
      client.invalidateQueries([presentationsCacheKey]);
    },
  });

  return {
    isLoading,
    createPresentationId,
  };
};
